module.exports = __webpack_public_path__ + "img/close.4248d375-b2c6030f.ff9a9fd7.svg";